import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';
import HighLightsDetails
  from 'components/dashboard/appearance-content/HighLightsDetails';


import './HighLightsContent.css';


const HighLightsContent = props => {
  const { me, patchUser } = props;
  const { t } = useTranslation();

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('highlights_is_active', checked);
    patchUser(form);
  };

  return (
    <ProSectionPlaceholder
      key="highlights-pro-feature-key"
      locked={me && me.subscription && !me.subscription.ff_highlights}
      className="highlights-content__component"
      text={<>{t("Highlights can be added on the PRO plan. Check it")}</>}
    >
      <div className="header-section">
        <div className="text-block">
          {t("Add the main highlights on your HeyLink.me page")}
        </div>
        <div className="checkbox-wrapper">
          <div className="option">{t("OFF")}</div>
          <Checkbox
            toggle
            checked={me.highlights_is_active}
            onChange={onCheckboxChange}
          />
          <div className="option">{t("ON")}</div>
        </div>
      </div>

      {me.highlights_is_active &&
        <div className="details-section">
          <HighLightsDetails />
        </div>
      }
    </ProSectionPlaceholder>
  );
};

HighLightsContent.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};

HighLightsContent.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(HighLightsContent);
